import { useTranslation } from "react-i18next";
import { TextField } from "@/shared/ui/core";
import { RepeatableList, TextAreaField } from "@/features/admin/components";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { useBlockFilled } from "./useBlockFilled";

/**
 * Bloque 8 · Las cifras grandes.
 *
 * La CIFRA es texto, no un número: en la ficha se leen cosas como
 * "98 %", "3×" o "24 h", y ninguna de las tres es un número que se pueda
 * sumar. Guardarla como número obligaría a inventar un campo aparte para
 * el símbolo, y el símbolo es la mitad del mensaje.
 */
export function EditorialStatsBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.stats`;
  const filled = useBlockFilled(name);

  return (
    <EditorialBlock
      name={name}
      title={t("Cifras")}
      description={t("Los números grandes que se leen de lejos.")}
      filled={filled}
    >
      <TextField
        name={`${name}.title`}
        label={t("Título del bloque")}
        placeholder={t("En números")}
      />
      <TextAreaField name={`${name}.intro`} label={t("Entradilla")} rows={2} />

      <div className="sm:col-span-2">
        <RepeatableList
          name={`${name}.items`}
          max={12}
          addLabel={t("Añadir cifra")}
          itemLabel={(index) => t("Cifra {{n}}", { n: index + 1 })}
          emptyHint={t("Todavía no hay cifras. Añade la primera.")}
          newItem={() => ({ number: "", label: "", description: "" })}
        >
          {({ name: row }) => (
            <div className="grid grid-cols-1 items-start gap-4 sm:grid-cols-3">
              <TextField
                name={`${row}.number`}
                label={t("Cifra")}
                placeholder="98 %"
                hint={t("Con su símbolo: «3×», «24 h».")}
              />
              <TextField
                name={`${row}.label`}
                label={t("Etiqueta")}
                placeholder={t("de absorción")}
              />
              <TextField name={`${row}.description`} label={t("Detalle")} />
            </div>
          )}
        </RepeatableList>
      </div>
    </EditorialBlock>
  );
}
